import PropTypes from 'prop-types'

import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import useAgencyContact from '@hooks/useAgencyContact'

import { confirmDelete } from '@functions/entity'

const AgencyContactListItem = (props) => {
  const { agencyContact } = props
  const {
    contact_type,
    email,
    name,
    phone,
  } = agencyContact

  const {
    callbacks: {
      createOrEditAgencyContact,
      deleteAgencyContact: deleteFn,
    },
  } = useAgencyContact(agencyContact)

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure?',
      entityName: 'Agency Contact',
    },
  }

  return (
    <DashboardModuleListItem
      secondaryText={email}
      title={name}
    >
      <DashboardModuleListItem.TertiaryText>
        <Text style={{ textTransform: 'capitalize' }} textAlign="end">{contact_type}</Text>
        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          marginTop="small"
          textAlign="end"
          variant="ellipsis"
        >
          {phone}
        </Text>
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditAgencyContact()}
          type="edit"
        />

        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

AgencyContactListItem.propTypes = {
  agencyContact: PropTypes.object.isRequired,
}

export default AgencyContactListItem
